import React from 'react';
import { useNavigate } from "react-router-dom";

import { Button, Form, Modal } from 'react-bootstrap';
import {IoIosArrowForward} from 'react-icons/io';

import '../EmailVerification.scss';

const CodeRejectModal = (props: any) => {

  const navigate = useNavigate();
  const goHome = (): void => {
    window.location.replace('https://motorsportgames.com/')
  }

  const getMessageFromNakamaError = (message: string): string | null => {

    if(message == void(0) || message?.length == 0) return null;

    try
    {
      const errorBodyIndex = message.indexOf("body:") + 6;
      const errorBody = message.substring(errorBodyIndex, message.length);

      return JSON.parse(errorBody).message;
    } catch (e) {
      return message;
    }
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      className='code-modal-container-lmu'
    >
      <img src="/lmu-logo-full.png" height="240" className="verify-logo-lmu" />
      <Modal.Header className="code-modal-header-lmu msg-header-text-lmu flex-col">
        <Modal.Title id="contained-modal-title-vcenter" className="msg-header-text-lmu code-modal-title">
          E-mail Verification Failed 
        </Modal.Title>
        <Modal.Title id="contained-modal-title-vcenter2" className="msg-header-text-lmu code-modal-title">
          {props?.info?.status ?? "Error"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="code-modal-body-lmu msg-body-text-lmu">
        <div className="container msg-body-text-lmu">
          <div className="row msg-body-text-lmu">
            The verification link is invalid.
          </div>
          <br></br>
          <div className="row msg-body-text-lmu">
            {getMessageFromNakamaError(props?.info?.Message) ?? "Unknown error"}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="code-modal-footer-lmu msg-body-text-lmu">
        <Button className="code-modal-submit-button msg-body-text-lmu"
          onClick={goHome}>
          <span>OK
            <IoIosArrowForward className="code-modal-submit-icon" size="0.75rem"/>
          </span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CodeRejectModal;
